import { SUPPORTED_COUNTRIES } from './Country';
/**
 * The states supported by this system.
 *
 * Adding a state here will make it an option only if the associated country is in the list of supported countries.
 */
export const SUPPORTED_STATES = [
    // https://en.wikipedia.org/wiki/ISO_3166-2:AU
    { code: 'au-act', name: 'Australian Capital Territory', countryCode: 'au' },
    { code: 'au-nsw', name: 'New South Wales', countryCode: 'au' },
    { code: 'au-nt', name: 'Northern Territory', countryCode: 'au' },
    { code: 'au-qld', name: 'Queensland', countryCode: 'au' },
    { code: 'au-sa', name: 'South Australia', countryCode: 'au' },
    { code: 'au-tas', name: 'Tasmania', countryCode: 'au' },
    { code: 'au-vic', name: 'Victoria', countryCode: 'au' },
    { code: 'au-wa', name: 'Western Australia', countryCode: 'au' },
    // https://en.wikipedia.org/wiki/ISO_3166-2:CA
    { code: 'ca-ab', name: 'Alberta', countryCode: 'ca' },
    { code: 'ca-bc', name: 'British Columbia', countryCode: 'ca' },
    { code: 'ca-mb', name: 'Manitoba', countryCode: 'ca' },
    { code: 'ca-nb', name: 'New Brunswick', countryCode: 'ca' },
    { code: 'ca-nl', name: 'Newfoundland And Labrador', countryCode: 'ca' },
    { code: 'ca-ns', name: 'Nova Scotia', countryCode: 'ca' },
    { code: 'ca-on', name: 'Ontario', countryCode: 'ca' },
    { code: 'ca-pe', name: 'Prince Edward Island', countryCode: 'ca' },
    { code: 'ca-qc', name: 'Quebec', countryCode: 'ca' },
    { code: 'ca-sk', name: 'Saskatchewan', countryCode: 'ca' },
    { code: 'ca-nt', name: 'Northwest Territories', countryCode: 'ca' },
    { code: 'ca-nu', name: 'Nunavut', countryCode: 'ca' },
    { code: 'ca-yt', name: 'Yukon', countryCode: 'ca' },
    // https://en.wikipedia.org/wiki/ISO_3166-2:IE
    { code: 'ie-c', name: 'Connacht', countryCode: 'ie' },
    { code: 'ie-l', name: 'Leinster', countryCode: 'ie' },
    { code: 'ie-m', name: 'Munster', countryCode: 'ie' },
    { code: 'ie-u', name: 'Ulster', countryCode: 'ie' },
    // https://en.wikipedia.org/wiki/ISO_3166-2:GB
    { code: 'gb-eng', name: 'England', countryCode: 'gb' },
    { code: 'gb-nir', name: 'Northern Ireland', countryCode: 'gb' },
    { code: 'gb-sct', name: 'Scotland', countryCode: 'gb' },
    { code: 'gb-wls', name: 'Wales', countryCode: 'gb' },
    // https://en.wikipedia.org/wiki/ISO_3166-2:US
    { code: 'us-al', name: 'Alabama', countryCode: 'us' },
    { code: 'us-ak', name: 'Alaska', countryCode: 'us' },
    { code: 'us-az', name: 'Arizona', countryCode: 'us' },
    { code: 'us-ar', name: 'Arkansas', countryCode: 'us' },
    { code: 'us-ca', name: 'California', countryCode: 'us' },
    { code: 'us-co', name: 'Colorado', countryCode: 'us' },
    { code: 'us-ct', name: 'Connecticut', countryCode: 'us' },
    { code: 'us-de', name: 'Delaware', countryCode: 'us' },
    { code: 'us-dc', name: 'District of Columbia', countryCode: 'us' },
    { code: 'us-fl', name: 'Florida', countryCode: 'us' },
    { code: 'us-ga', name: 'Georgia', countryCode: 'us' },
    { code: 'us-hi', name: 'Hawaii', countryCode: 'us' },
    { code: 'us-id', name: 'Idaho', countryCode: 'us' },
    { code: 'us-il', name: 'Illinois', countryCode: 'us' },
    { code: 'us-in', name: 'Indiana', countryCode: 'us' },
    { code: 'us-ia', name: 'Iowa', countryCode: 'us' },
    { code: 'us-ks', name: 'Kansas', countryCode: 'us' },
    { code: 'us-ky', name: 'Kentucky', countryCode: 'us' },
    { code: 'us-la', name: 'Louisiana', countryCode: 'us' },
    { code: 'us-me', name: 'Maine', countryCode: 'us' },
    { code: 'us-md', name: 'Maryland', countryCode: 'us' },
    { code: 'us-ma', name: 'Massachusetts', countryCode: 'us' },
    { code: 'us-mi', name: 'Michigan', countryCode: 'us' },
    { code: 'us-mn', name: 'Minnesota', countryCode: 'us' },
    { code: 'us-ms', name: 'Mississippi', countryCode: 'us' },
    { code: 'us-mo', name: 'Missouri', countryCode: 'us' },
    { code: 'us-mt', name: 'Montana ', countryCode: 'us' },
    { code: 'us-ne', name: 'Nebraska', countryCode: 'us' },
    { code: 'us-nv', name: 'Nevada', countryCode: 'us' },
    { code: 'us-nh', name: 'New Hampshire', countryCode: 'us' },
    { code: 'us-nj', name: 'New Jersey', countryCode: 'us' },
    { code: 'us-nm', name: 'New Mexico', countryCode: 'us' },
    { code: 'us-ny', name: 'New York', countryCode: 'us' },
    { code: 'us-nc', name: 'North Carolina', countryCode: 'us' },
    { code: 'us-nd', name: 'North Dakota  ', countryCode: 'us' },
    { code: 'us-oh', name: 'Ohio', countryCode: 'us' },
    { code: 'us-ok', name: 'Oklahoma', countryCode: 'us' },
    { code: 'us-or', name: 'Oregon', countryCode: 'us' },
    { code: 'us-pa', name: 'Pennsylvania', countryCode: 'us' },
    { code: 'us-ri', name: 'Rhode Island', countryCode: 'us' },
    { code: 'us-sc', name: 'South Carolina', countryCode: 'us' },
    { code: 'us-sd', name: 'South Dakota', countryCode: 'us' },
    { code: 'us-tn', name: 'Tennessee', countryCode: 'us' },
    { code: 'us-tx', name: 'Texas', countryCode: 'us' },
    { code: 'us-ut', name: 'Utah', countryCode: 'us' },
    { code: 'us-vt', name: 'Virginia', countryCode: 'us' },
    { code: 'us-va', name: 'Vermont', countryCode: 'us' },
    { code: 'us-wa', name: 'West Virginia', countryCode: 'us' },
    { code: 'us-wv', name: 'Washington', countryCode: 'us' },
    { code: 'us-wi', name: 'Wisconsin', countryCode: 'us' },
    { code: 'us-wy', name: 'Wyoming', countryCode: 'us' },
];
export function countryCodeToFullName(countryCode) {
    var _a;
    return (_a = SUPPORTED_COUNTRIES.find(({ code }) => countryCode === code)) === null || _a === void 0 ? void 0 : _a.name;
}
export function stateCodeToFullName(stateCode) {
    var _a;
    return (_a = SUPPORTED_STATES.find(({ code }) => stateCode === code)) === null || _a === void 0 ? void 0 : _a.name;
}
export function countryAndStateCodeToFullName(countryCode, stateCode) {
    const countryName = countryCodeToFullName(countryCode);
    const stateName = stateCodeToFullName(stateCode);
    return countryName ? [stateName, countryName].filter(Boolean).join(', ') : undefined;
}
